export default __webpack_public_path__ + "static/media/FotoPERSONAL.d5eea976.svg";